import { ICategory } from "./category";
import { FundAccountMember } from "./fund-account-member";
import { IInvitation } from "./invitation";
export interface Tiers {
  range: number;
  fee: number;
  last: boolean;
}
export interface Fund {
  fundAccountID: number;
  fundAccountName: string;
}
export interface FundGroup {
  fundGroupId: number;
  aumTiers: Tiers[];
  gvTiers: Tiers[];
  createdAt?: Date;
  updatedAt?: Date;
  funds: Fund[];
}
export enum FUND_STATUS_ENUM {
  ACTIVE = "ACTIVE",
  ARCHIVED = "ARCHIVED",
}

export interface IFundAccount {
  fundAccountId: number;
  fundAccountName: String;
  entityInformation?: {
    zip: string;
    city: string;
    role: string;
    type: string;
    state: string;
    entityZip: string;
    entityCity: string;
    entityName: string;
    entityRole: string;
    entityType: string;
    entityState: string;
    firstAddressLine: string;
    secondAddressLine: string;
    entityFirstAddressLine: string;
    entitySecondAddressLine: string;
  };
  total: number;
  availableBalance: number;
  interests?: ICategory[];
  fundAccountMembers?: FundAccountMember[];
  invitations?: IInvitation[];
  createdAt: Date;
  updatedAt: Date;
  group: FundGroup;
  reference: string | null;
  status?: FUND_STATUS_ENUM;
  archivedAt?: Date;
  isArchivable?: boolean;
  isDeletable?: boolean;
  sageIntacctSyncTime?: Date | null;
}
